import {
  type CanvasElement,
  convertFormatToTableColumnFormat,
  type PartialPropsOf,
  type PropsOf,
} from '@blaze-runtime/engine-domain';
import { DEPRECATED_DURATION_FORMAT_MAPPINGS } from '@blaze-shared/elements-domain';

import { hasProps } from './element-props-guards';
import { type PregenerationData } from './pregeneration';

export function updateGeneratedTextInputContent(
  inputData: PregenerationData,
  props: PartialPropsOf<'textField' | 'textInput'>,
  existingElement?: CanvasElement,
): PartialPropsOf<'textField' | 'textInput'> {
  const format = inputData.column.format;
  const inputDataType = inputData.column.dataType;

  let contentInput: PartialPropsOf<'textField' | 'textInput'>['content'];
  if (inputDataType === 'String' || inputDataType === 'Link') {
    contentInput = {
      input: { format: convertFormatToTableColumnFormat(format?.formatType) ?? 'text' },
    };
  } else if (inputDataType === 'Number') {
    contentInput = {
      input: {
        format: convertFormatToTableColumnFormat(format?.formatType) ?? 'number',
        currency: format?.formatType === 'Currency' ? format?.currencySymbol : undefined,
        precision: inputData.column.precision,
      },
    };
  } else if (inputDataType === 'DateTime') {
    const existingFormat = !hasProps<PropsOf<'textField' | 'textInput'>>(existingElement)
      ? undefined
      : existingElement.props?.content?.input?.format;
    const inputFormat = (existingFormat === 'date' ? existingFormat : undefined) ?? 'datetime';
    contentInput = {
      input: { format: inputFormat },
    };
  } else if (inputDataType === 'Duration') {
    let durationFormat = format?.durationFormat;
    if (durationFormat) {
      durationFormat = DEPRECATED_DURATION_FORMAT_MAPPINGS[durationFormat] ?? durationFormat;
    }
    contentInput = {
      input: {
        format: 'duration',
        duration: durationFormat,
      },
    };
  } else {
    contentInput = {
      input: { format: inputData.format },
    };
  }

  return {
    ...props,
    content: {
      ...props.content,
      ...contentInput,
    },
  };
}
